<script>
  import MonthSummary from "./month/MonthSummary.svelte";
  import { _ } from "svelte-i18n";
  export let sessions;
</script>

<div class="calendar__body">
  <div class="calendar-months">
    <div class="calendar-months__content" style="">
      <MonthSummary date={new Date()} {sessions} />
    </div>
    <div class="button-next-month-wrap">
      <button class="button button--icon button--icon-add button-next-month"
        ><span>{$_("plans.nav.nextMonth")}</span></button
      >
    </div>
  </div>
</div>
